import { render } from "./ProfileForm.vue?vue&type=template&id=6663710c&scoped=true"
import script from "./ProfileForm.vue?vue&type=script&lang=js"
export * from "./ProfileForm.vue?vue&type=script&lang=js"

import "./ProfileForm.vue?vue&type=style&index=0&id=6663710c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6663710c"]])

export default __exports__